import { Identifiable, ProjectPortfolio } from "@planzone/dto";
import { Filter } from "@planzone/dto";

import { isFilteredByProjectPortfolios } from "./projectPortfolios";

function isProjectPortfolioFiltered(
  projectPortfolio: Identifiable<ProjectPortfolio>,
  filter: Filter,
): boolean {
  return [isFilteredByProjectPortfolios].reduce(
    (isFiltered, applyFilter) =>
      isFiltered ? isFiltered : applyFilter(projectPortfolio, filter),
    false,
  );
}

export { isProjectPortfolioFiltered };
